import { Provider } from '@angular/core';
import { EnvConfig } from '../interfaces/env-config';
import { EnvConfigService } from './env-config.service';
 
export function ProviderEnvConfigService (config: EnvConfig): Provider[] {
  return [
    {
      provide: EnvConfigService,
      useFactory: () => {
        const svc = new EnvConfigService();
        svc.setConfig(config);
        return svc;
      }
    }
  ];
}

